/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RequestOptions,
    RequestOptionsFromJSON,
    RequestOptionsFromJSONTyped,
    RequestOptionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface DocumentOverride
 */
export interface DocumentOverride {
    /**
     * 
     * @type {RequestOptions}
     * @memberof DocumentOverride
     */
    _requestOptions?: RequestOptions;
}

export function DocumentOverrideFromJSON(json: any): DocumentOverride {
    return DocumentOverrideFromJSONTyped(json, false);
}

export function DocumentOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentOverride {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        '_requestOptions': !exists(json, 'requestOptions') ? undefined : RequestOptionsFromJSON(json['requestOptions']),
    };
}

export function DocumentOverrideToJSON(value?: DocumentOverride | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'requestOptions': RequestOptionsToJSON(value._requestOptions),
    };
}


